/**
 * Persisted account-selection view across remounts (and in-component view state).
 */
export enum AccountSelectionViewType {
	Single = 0,
	Select = 1,
	Confirm = 2,
	Delete = 3,
	NotFound = 4,
}

export const accountSelectionViewStateRef = {
	current: AccountSelectionViewType.NotFound,
};

export function resetAccountSelectionViewState() {
	accountSelectionViewStateRef.current = AccountSelectionViewType.NotFound;
}
